import Vue from 'vue'
const layoutEditorCommon = {
  methods: {
    selectLayerInVieport ({ layer, $event }) {
      this.selectLayer(layer, $event)
    },
    selectLayer (layer, $event) {
      if (this.closeRightClickMenu) this.closeRightClickMenu()
      if (!$event.shiftKey) {
        if (!$event.ctrlKey && !$event.metaKey) {
          this.$store.commit('Medium/SET_PLAYITEMS_SELECTED_RIGHT', [layer])
        } else {
          this.$store.commit('Medium/TOGGLE_PLAYITEM_SELECTED_RIGHT', layer)
        }
      }
      if ($event.shiftKey) {
        if (!$event.ctrlKey && !$event.metaKey) {
          const previouslySelectedItemOrder = this.$store.state.Medium.playitems_selected_right[this.$store.state.Medium.playitems_selected_right.length - 1].order
          const startOrder = previouslySelectedItemOrder < layer.order ? previouslySelectedItemOrder : layer.order
          const endOrder = previouslySelectedItemOrder < layer.order ? layer.order : previouslySelectedItemOrder
          this.$store.commit('Medium/SET_PLAYITEMS_SELECTED_RIGHT', this.playListWithContentSimple.PlayListItems.filter((pli) => {
            return (pli.order <= endOrder) && (pli.order >= startOrder)
          }))
          this.playListWithContentSimple.PlayListItems.filter((pli) => {
            return startOrder <= pli.order <= endOrder
          })
        } else {
          console.log('TODO - Shift-shrink playitems selection (shift + ctrl)')
        }
      }
      if (this.selectedLayer && this.selectedLayer.id === layer.id) {
        this.selectedLayer = undefined
        return
      }
      if (
        !this.lockedLayers.find(l => l.id === layer.id) &&
        !this.hiddenLayers.find(l => l.id === layer.id)
      ) {
        this.selectedLayer = layer
      }
    },
    async patchLayout () {
      if (!this.playListWithContentSimple || !this.playListWithContentSimple.id) return
      await Vue.axios
        .patch(`Medium/${this.playListWithContentSimple.id}`,
          {
            playListLayoutWidth: this.playListWithContentSimple.playListLayoutWidth,
            playListLayoutHeight: this.playListWithContentSimple.playListLayoutHeight
          }
        )
      await this.loadData()
    }
  }

}
export default layoutEditorCommon



// WEBPACK FOOTER //
// ./src/components/Medium/LayoutEditor/commonLayoutEditor.mixin.js